import { Language } from '@ha/intl';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { City } from './types/City';

interface FeaturedCitiesResource {
  cities: City[];
  count: number;
}

export interface Query {
  lang?: Language;
  include?: string;
  exclude?: string;
}

export default (makeCall: MakeCall) => (query?: Query) =>
  makeCall<FeaturedCitiesResource>('GET', `/api/v2/geonames/cities/featured`, {
    query,
  });
